'use client'

import React, { useEffect, useState } from 'react'
import { ModalDialog, ModalDialogContent } from '@dustin-web/microsite-components/src/modal-dialog'

// Some CMS-pages use a Bootstrap 3 modal-component that only exists in the legacy-web
// Therefore we need to convert these modals to our own dialog-component

export const ModalToDialog = ({
  modalId,
  children,
}: {
  modalId: string
  children: React.ReactNode
}) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const triggerBtn = document.querySelector(`[data-target="#${modalId}"]`)

    triggerBtn?.addEventListener('click', e => {
      e.preventDefault()
      setOpen(true)
    })
  }, [])

  useEffect(() => {
    if (!open) {
      return
    }

    const onDismiss = () => {
      setOpen(false)
    }

    let dismissBtn: Element | null

    setTimeout(() => {
      // TODO: this might not work if there are multiple modals on the same page
      dismissBtn = document.querySelector(`[data-dismiss="modal"]`)
      dismissBtn?.addEventListener('click', onDismiss)
    }, 0)

    return () => {
      dismissBtn?.removeEventListener('click', onDismiss)
    }
  }, [open])

  return (
    <ModalDialog show={open} handleClose={() => setOpen(false)}>
      <ModalDialogContent className="u-pt-24">{children}</ModalDialogContent>
    </ModalDialog>
  )
}
